__turbopack_context__.v({
  "block": "split-button-module__yKrKpW__block",
  "main": "split-button-module__yKrKpW__main",
  "menu": "split-button-module__yKrKpW__menu",
  "menuHeader": "split-button-module__yKrKpW__menuHeader",
  "splitButton": "split-button-module__yKrKpW__splitButton",
  "toggle": "split-button-module__yKrKpW__toggle",
});
